// extracted by mini-css-extract-plugin
export default {"root":"classes_root__Mr0+X","icon":"classes_icon__wTNVC","collapsed":"classes_collapsed__kMBYG"};